import type { ContentProps } from '../../content.types'
import * as Comp from './content-actions-text-styles'

import {
  DISPLAY_NAME,
  type ScopedProps,
  useContentContext,
} from '../../content'

type ContentActionsTextProps = ContentProps

export function ContentActionsText(props: ContentActionsTextProps) {
  const { children, testID, __scopeContent } =
    props as ScopedProps<ContentActionsTextProps>

  const { type } = useContentContext(DISPLAY_NAME, __scopeContent)

  return (
    <Comp.Wrapper testID={testID} type={type}>
      {children}
    </Comp.Wrapper>
  )
}
